import api from './api';
import { CURATOR } from './endpoints';

const deleteTip = id => api.delete(`${CURATOR}/tip/${id}/`);

const postTip = tip => api.post(`${CURATOR}/tip/`, tip);

const putTip = tip => api.put(`${CURATOR}/tip/`, tip);

const upsertTip = tip => (tip.id ? putTip(tip) : postTip(tip));

export default {
  deleteTip,
  postTip,
  putTip,
  upsertTip,
};
